export const debug = (...msg: any[]) => console.debug("WebAR |", ...msg)
export const warn = (...msg: any[]) => console.warn("WebAR |", ...msg)
